import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deleteGroup = {
  name: "deleteGroup" as const,

  input: z.object({ groupId: zExt.objectId() }),

  output: z.object({ success: z.boolean() }),
};
